@if (status) {
  <alert [type]="type" [dismissible]="true" dismissOnTimeout="5000" >
    {{msg}}
  </alert>
}
